(function () {
  function applyAdaReportFixes() {
    document.querySelectorAll('a.link').forEach(function (link) {
      var text = (link.textContent || '').trim().toLowerCase();
      if (text === 'view all') {
        if (!link.getAttribute('href') || link.getAttribute('href') === '') {
          link.setAttribute('href', '/collections/all');
        }
        if (!link.getAttribute('aria-label')) {
          link.setAttribute('aria-label', 'View all products');
        }
      }
    });

    document.querySelectorAll('iframe').forEach(function (iframe) {
      if (!iframe.getAttribute('title')) {
        iframe.setAttribute('title', iframe.closest('[data-description]')?.getAttribute('data-description') || 'Embedded video');
      }
    });

    document.querySelectorAll('.main-nav__item--toggle').forEach(function (summary) {
      if (!summary.getAttribute('aria-label')) {
        var text = (summary.textContent || '').replace(/\s+/g, ' ').trim();
        summary.setAttribute('aria-label', text ? ('Open ' + text + ' navigation menu') : 'Open navigation menu');
      }
      if (!summary.getAttribute('role')) {
        summary.setAttribute('role', 'button');
      }
    });

    /* Latest audit: visible header/footer strip content must be inside named landmark/region. */
    document.querySelectorAll('.shopify-section.cc-promo-strip, .shopify-section.cc-icons-with-text').forEach(function (section) {
      if (!section.getAttribute('role')) section.setAttribute('role', 'region');
      if (!section.getAttribute('aria-label')) {
        var heading = section.querySelector('h1,h2,h3,h4,h5,h6,strong');
        section.setAttribute('aria-label', heading ? heading.textContent.trim() : 'Store information');
      }
    });

    /* Latest audit: horizontally scrollable sliders must be keyboard reachable. */
    document.querySelectorAll('.slider[id^="slider-"]').forEach(function (slider) {
      if (!slider.hasAttribute('tabindex')) slider.setAttribute('tabindex', '0');
      if (!slider.getAttribute('role')) slider.setAttribute('role', 'region');
      if (!slider.getAttribute('aria-label')) {
        var product = slider.closest('.card, .card--product, product-card-image-slider');
        var title = product && product.querySelector('.card-link, a[aria-label]');
        var label = title ? (title.getAttribute('aria-label') || title.textContent || '').trim() : '';
        slider.setAttribute('aria-label', label ? (label + ' image carousel') : 'Scrollable carousel');
      }
    });

    /* Remove empty home links used by some sections when configured as a fallback. */
    document.querySelectorAll('a.link[href="/"]').forEach(function (link) {
      if ((link.textContent || '').trim().toLowerCase() === 'view all' && !link.getAttribute('aria-label')) {
        link.setAttribute('aria-label', 'View all products');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAdaReportFixes);
  } else {
    applyAdaReportFixes();
  }
  document.addEventListener('shopify:section:load', applyAdaReportFixes);
})();
